import Model, { Request } from '../model'
import Enum from '../enums'

export default class Upload extends Model {
  static modelName () {
    return 'upload'
  }

  objectID () {
    return this.idPhoto
  }

  relations () {
    return {
      dataType: { type: DataType },
      type: { type: UploadType },
    }
  }

  static upload ({ file, params = {} }, options = {}) {
    const url = this.modelBaseURL()

    const formData = new FormData()
    formData.append('photo', file)

    for (const param in params) {
      formData.append(param, params[param])
    }

    const request = Request.post(url, formData)
    request.options = options

    return this.requestItem(request, this)
  }

  get isDataTypePhoto () {
    return this.dataType === DataType.photo
  }

  get isDataTypeDocument () {
    return this.dataType === DataType.document
  }

  get isTypeCustomer () {
    return this.type === UploadType.customer
  }

  get isTypeReservation () {
    return this.type === UploadType.reservation
  }

  get isTypeReservationCustomer () {
    return this.type === UploadType.reservationCustomer
  }

  get isTypeLocation () {
    return this.type === UploadType.location
  }
}

export const DataType = new Enum({
  photo: { value: 0, description: 'general.photo' },
  document: { value: 1, description: 'api.models.upload.document' },
})

export const UploadType = new Enum({
  customer: { value: 0, description: 'general.customer' },
  reservation: { value: 1, description: 'general.reservation' },
  reservationCustomer: { value: 2, description: 'api.models.reservationCustomer' },
  location: { value: 3, description: 'general.location' },
})